export const AttributeSelectionForm = {
  model: 'AttributeSelection',
  format: [
    {
      widths: 'equal',
      fields: {
        value: {
          type: 'text',
          label: 'Variant Value',
        },
        multiplier: {
          type: 'text',
          label: 'Variant Multiplier',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        order: {
          type: 'number',
          label: 'Display Order',
          helpText: 'Lower numbers appear first (1, 2, 3...)',
        },
      },
    },
  ],
}
